<template>
  <v-row>
    <visitors-list />
  </v-row>
</template>

<script>
import VisitorsList from '@/components/Services/Hosting/Shared/Stats/Metrics/VisitorsList'

export default {
  name: 'VisitorsView',
  components: { VisitorsList },
}
</script>
